webpackJsonp([10,47],{

/***/ 1298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['activeDialog', 'length'],
  methods: {
    saveRole: function saveRole() {
      if (this.roleTitle) {
        var payload = {
          level: this.roleLevel,
          priviledges: _objectSpread(_objectSpread({}, this.newPriviledge), {}, {
            title: this.roleTitle
          })
        };
        this.$store.dispatch('addPriviledge', payload);
        this.activeDialog();
        this.roleTitle = '';
        this.newPriviledge = {
          events: {
            create_event: false
          },
          email_updates: {
            access: false,
            limit: 0
          },
          economic_impact: {},
          activity_stream: {
            post_to_activity: false
          },
          chat: {
            voice_chat: false,
            video_chat: false,
            private_chat: false,
            group_chat: false
          },
          groups: {
            create_event: false,
            create_group: false,
            post_to_group: false
          }
        };
      } else {
        this.valid = false;
      }
    },
    giveAllAccessToEconomicImpact: function giveAllAccessToEconomicImpact() {
      var _iterator = _createForOfIteratorHelper(this.analysisList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var analysis = _step.value;
          this.newPriviledge.economic_impact[analysis.id] = this.newPriviledge.economic_impact.all_access;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.newPriviledge.economic_impact.has_access = this.newPriviledge.economic_impact.all_access;
    },
    unCheckEconomicImpactAllAccess: function unCheckEconomicImpactAllAccess(val) {
      var hasTrueValues = false;
      this.newPriviledge.economic_impact.all_access = false;

      for (var value in this.newPriviledge.economic_impact) {
        if (this.newPriviledge.economic_impact[value] && value !== 'has_access') {
          hasTrueValues = true;
        }
      }

      this.newPriviledge.economic_impact.has_access = hasTrueValues;
    }
  },
  data: function data() {
    return {
      limits: [{
        text: '5',
        value: 5
      }, {
        text: '10',
        value: 10
      }],
      roleTitle: '',
      valid: true,
      newPriviledge: {
        events: {
          create_event: false
        },
        email_updates: {
          access: false,
          limit: 0
        },
        activity_stream: {
          post_to_activity: false
        },
        economic_impact: {},
        chat: {
          voice_chat: false,
          video_chat: false,
          private_chat: false,
          group_chat: false
        },
        groups: {
          create_event: false,
          create_group: false,
          post_to_group: false
        }
      },
      analysisList: [{
        text: 'Spending Analysis by Geography',
        id: 'spending-analysis-by-geography',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 3050px;'><object class='tableauViz' width='1000' height='3050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;GeorgiaDoD_Geography' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/GeorgiaDoD_Geography?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'DoD Contract Trends',
        id: 'dod-contract-trends',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 1550px;'><object class='tableauViz' width='1000' height='1550' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDContractTrends' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDContractTrends?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'Military Installations',
        id: 'military-installations',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 827px;'><object class='tableauViz' width='1000' height='827' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_MilitaryInstallations_12172018&#47;MilitaryInstallations' /><param name='tabs' value='no' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_MilitaryInstallations_12172018/MilitaryInstallations?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'Prime-Sub Spending Flow',
        id: 'prime-sub-spending-flow',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 4050px;'><object class='tableauViz' width='1000' height='4050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDPrime-SubSpendingFlow' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDPrime-SubSpendingFlow?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'DoD Agency Spending Flow',
        id: 'dod-agency-spending-flow',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 4050px;'><object class='tableauViz' width='1000' height='4050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDAgencySpendingFlow' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDAgencySpendingFlow?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'Future Needs of the DoD',
        id: 'future-needs-of-the-dod',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 850px;'><object class='tableauViz' width='1000' height='850' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_Part3_12172018&#47;FutureNeedsoftheDoD' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_Part3_12172018/FutureNeedsoftheDoD?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'DoD Contract View',
        id: 'dod-contract-view',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 1550px;'><object class='tableauViz' width='1000' height='1550' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDContractView' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDContractView?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'DoD Contractor View',
        id: 'dod-contractor-view',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 1550px;'><object class='tableauViz' width='1000' height='1550' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDContractorView' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDContractorView?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'GDX Directory vs. Georgia DoD Contract Winners',
        id: 'gdx-directory-vs-georgia-dod-contract-winners',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 850px;'><object class='tableauViz' width='1000' height='850' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_Part3_12172018&#47;GDXDirectoryvs_GeorgiaDoDContractWinners' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_Part3_12172018/GDXDirectoryvs_GeorgiaDoDContractWinners?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'Georgia Contractor Analysis',
        id: 'georgia-contractor-analysis',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 3050px;'><object class='tableauViz' width='1000' height='3050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;GeorgiaDoD_Contractor' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/GeorgiaDoD_Contractor?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }]
    };
  },
  computed: {
    roleLevel: function roleLevel() {
      return this.length;
    }
  }
};

/***/ }),

/***/ 1299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components_AdminSideBar_vue__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Components_AdminSideBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Components_AdminSideBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_PageFooter_vue__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_PageFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Components_PageFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Priviledges_NewRole_vue__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Priviledges_NewRole_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Priviledges_NewRole_vue__);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    AdminSideBarMenu: __WEBPACK_IMPORTED_MODULE_0__Components_AdminSideBar_vue___default.a,
    PageFooter: __WEBPACK_IMPORTED_MODULE_1__Components_PageFooter_vue___default.a,
    NewRole: __WEBPACK_IMPORTED_MODULE_2__Priviledges_NewRole_vue___default.a
  },
  computed: {
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    all_priviledges: function all_priviledges() {
      var raw = this.$store.getters.getAllPriviledges;
      var notAllowed = ['Client Admin', 'Business Admin', 'Staff', 'User', 'Disabled'];
      this.length = Object.keys(raw).length + 1;
      var filtered = Object.keys(raw).filter(function (key) {
        return !notAllowed.includes(raw[key].title);
      }).reduce(function (obj, key) {
        obj[key] = raw[key];
        return obj;
      }, {});
      return filtered;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    selectedPriviledge: function selectedPriviledge() {
      if (this.currentRole) {
        return this.all_priviledges[this.currentRole];
      }

      return null;
    },
    roles: function roles() {
      var _this = this;

      var allRoles = [];
      var levels = Object.keys(this.all_priviledges);
      levels.forEach(function (role) {
        var data = {};
        data['text'] = _this.all_priviledges[role]['title'];
        data['value'] = role;
        allRoles.push(data);
      });
      return allRoles;
    },
    screenWidth: function screenWidth() {
      return this.$vuetify.breakpoint.width;
    }
  },
  methods: {
    updateData: function updateData() {
      var payload = {
        level: this.currentRole,
        priviledges: this.all_priviledges[this.currentRole]
      };
      this.$store.dispatch('updatePriviledge', payload);
    },
    giveAllAccessToEconomicImpact: function giveAllAccessToEconomicImpact() {
      var _iterator = _createForOfIteratorHelper(this.analysisList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var analysis = _step.value;
          this.selectedPriviledge.economic_impact[analysis.id] = this.selectedPriviledge.economic_impact.all_access;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.selectedPriviledge.economic_impact.has_access = this.selectedPriviledge.economic_impact.all_access;
      this.updateData();
    },
    unCheckEconomicImpactAllAccess: function unCheckEconomicImpactAllAccess(val) {
      var hasTrueValues = false;
      this.selectedPriviledge.economic_impact.all_access = false;

      for (var value in this.selectedPriviledge.economic_impact) {
        if (this.selectedPriviledge.economic_impact[value] && value !== 'has_access') {
          hasTrueValues = true;
        }
      }

      this.selectedPriviledge.economic_impact.has_access = hasTrueValues;
      this.updateData();
    },
    deleteRole: function deleteRole() {
      var payload = {
        title: this.currentRole
      };
      this.$store.dispatch('deleteRole', payload);
      this.currentRole = 0;
      this.dialog = false;
    },
    activeDialog: function activeDialog() {
      this.open_modal = !this.open_modal;
    }
  },
  data: function data() {
    return {
      currentRole: 0,
      length: 0,
      open_modal: false,
      dialog: false,
      limits: [{
        text: '5',
        value: 5
      }, {
        text: '10',
        value: 10
      }],
      analysisList: [{
        text: 'Spending Analysis by Geography',
        id: 'spending-analysis-by-geography',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 3050px;'><object class='tableauViz' width='1000' height='3050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;GeorgiaDoD_Geography' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/GeorgiaDoD_Geography?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'DoD Contract Trends',
        id: 'dod-contract-trends',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 1550px;'><object class='tableauViz' width='1000' height='1550' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDContractTrends' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDContractTrends?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'Military Installations',
        id: 'military-installations',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 827px;'><object class='tableauViz' width='1000' height='827' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_MilitaryInstallations_12172018&#47;MilitaryInstallations' /><param name='tabs' value='no' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_MilitaryInstallations_12172018/MilitaryInstallations?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'Prime-Sub Spending Flow',
        id: 'prime-sub-spending-flow',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 4050px;'><object class='tableauViz' width='1000' height='4050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDPrime-SubSpendingFlow' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDPrime-SubSpendingFlow?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'DoD Agency Spending Flow',
        id: 'dod-agency-spending-flow',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 4050px;'><object class='tableauViz' width='1000' height='4050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDAgencySpendingFlow' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDAgencySpendingFlow?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'Future Needs of the DoD',
        id: 'future-needs-of-the-dod',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 850px;'><object class='tableauViz' width='1000' height='850' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_Part3_12172018&#47;FutureNeedsoftheDoD' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_Part3_12172018/FutureNeedsoftheDoD?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'DoD Contract View',
        id: 'dod-contract-view',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 1550px;'><object class='tableauViz' width='1000' height='1550' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDContractView' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDContractView?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'DoD Contractor View',
        id: 'dod-contractor-view',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 1550px;'><object class='tableauViz' width='1000' height='1550' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;DoDContractorView' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/DoDContractorView?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'GDX Directory vs. Georgia DoD Contract Winners',
        id: 'gdx-directory-vs-georgia-dod-contract-winners',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 850px;'><object class='tableauViz' width='1000' height='850' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_Part3_12172018&#47;GDXDirectoryvs_GeorgiaDoDContractWinners' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_Part3_12172018/GDXDirectoryvs_GeorgiaDoDContractWinners?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }, {
        text: 'Georgia Contractor Analysis',
        id: 'georgia-contractor-analysis',
        html: "<div class='tableauPlaceholder' style='width: 1000px; height: 3050px;'><object class='tableauViz' width='1000' height='3050' style='display:none;'><param name='host_url' value='https%3A%2F%2Fus-east-1.online.tableau.com%2F' /> <param name='embed_code_version' value='3' /> <param name='site_root' value='&#47;t&#47;tsvanalytics' /><param name='name' value='GDEcD_EconomicAnalysis_12172018&#47;GeorgiaDoD_Contractor' /><param name='tabs' value='yes' /><param name='toolbar' value='yes' /><param name='showAppBanner' value='false' /><param name='filter' value='iframeSizedToWindow=true' /></object></div>",
        embedLink: 'https://us-east-1.online.tableau.com/t/tsvanalytics/views/GDEcD_EconomicAnalysis_12172018/GeorgiaDoD_Contractor?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no'
      }]
    };
  },
  mounted: function mounted() {
    var payload = {
      meta: {
        'h1': 'Manage Access',
        'title': 'Manage Access',
        'description': 'Admin Settings',
        'keywords': '',
        'requiresAuth': true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit('setHeaderInfo', payload);
  }
};

/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"NewRole.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1375:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".title-toolbar[data-v-3f809752]{padding:0 20px!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/PriviledgesView.vue"],"names":[],"mappings":"AACA,gCACE,wBAA2B,CAC5B","file":"PriviledgesView.vue","sourcesContent":["\n.title-toolbar[data-v-3f809752] {\n  padding: 0 20px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1440:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1351);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("2c3b5448", content, true, {});

/***/ }),

/***/ 1464:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1375);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("142aa122", content, true, {});

/***/ }),

/***/ 1606:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1440)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1298),
  /* template */
  __webpack_require__(1638),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1638:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "grey",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Add New Role")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "color": "primary",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.saveRole()
      }
    }
  }, [_vm._v("Save Role")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "color": "red",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.activeDialog()
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "subheader": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Role Title",
      "required": ""
    },
    model: {
      value: (_vm.roleTitle),
      callback: function($$v) {
        _vm.roleTitle = $$v
      },
      expression: "roleTitle"
    }
  }), _vm._v(" "), (!_vm.valid) ? _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("Title field is required")]) : _vm._e()], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Events")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.newPriviledge.events.create_event),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.events, "create_event", $$v)
      },
      expression: "newPriviledge.events.create_event"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Create Events")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to create events")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Activity Stream")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.newPriviledge.activity_stream.post_to_activity),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.activity_stream, "post_to_activity", $$v)
      },
      expression: "newPriviledge.activity_stream.post_to_activity"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Post to Activity Stream")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to create post in activity stream")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Economic Impact")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.giveAllAccessToEconomicImpact()
      }
    },
    model: {
      value: (_vm.newPriviledge.economic_impact.all_access),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.economic_impact, "all_access", $$v)
      },
      expression: "newPriviledge.economic_impact.all_access"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("All Access")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Give full access to the economic impact module")])], 1)], 1), _vm._v(" "), _vm._l((_vm.analysisList), function(analysis, index) {
    return _c('v-list-tile', {
      key: index
    }, [_c('v-list-tile-action', [_c('v-checkbox', {
      attrs: {
        "readonly": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.unCheckEconomicImpactAllAccess()
        }
      },
      model: {
        value: (_vm.newPriviledge.economic_impact[analysis.id]),
        callback: function($$v) {
          _vm.$set(_vm.newPriviledge.economic_impact, analysis.id, $$v)
        },
        expression: "newPriviledge.economic_impact[analysis.id]"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(analysis.text))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Give access to the "), _c('span', {
      staticStyle: {
        "text-transform": "lowercase"
      }
    }, [_vm._v(_vm._s(analysis.text))])])], 1)], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Chat")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.newPriviledge.chat.group_chat),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.chat, "group_chat", $$v)
      },
      expression: "newPriviledge.chat.group_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Group Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to send messages in groups")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    model: {
      value: (_vm.newPriviledge.chat.private_chat),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.chat, "private_chat", $$v)
      },
      expression: "newPriviledge.chat.private_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Private Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to send private messages across users")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    model: {
      value: (_vm.newPriviledge.chat.video_chat),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.chat, "video_chat", $$v)
      },
      expression: "newPriviledge.chat.video_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Video Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Enables users access to video chats")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    model: {
      value: (_vm.newPriviledge.chat.voice_chat),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.chat, "voice_chat", $$v)
      },
      expression: "newPriviledge.chat.voice_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Voice Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Enables users access to voice chats")])], 1)], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Email Updates")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.newPriviledge.email_updates.access),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.email_updates, "access", $$v)
      },
      expression: "newPriviledge.email_updates.access"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Enable Access")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allows users to receive email updates")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Set limit for Email Update")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Limit the number of email updates")])], 1), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.newPriviledge.email_updates.limit),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.email_updates, "limit", $$v)
      },
      expression: "newPriviledge.email_updates.limit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "5",
      "value": 5
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "10",
      "value": 10
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.valid) ? _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("Title field is required")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "color": "primary",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.saveRole()
      }
    }
  }, [_vm._v("Save Role")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "color": "red",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.activeDialog()
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1667:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "height": "100%",
      "padding": "0"
    },
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "fill-height": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('AdminSideBarMenu'), _vm._v(" "), _c('v-flex', {
    staticClass: "dashboard-view"
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Access")])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "bordered-card",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n            Manage Access\n          ")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "subheader": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "title-toolbar"
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    staticClass: "input-group--focused",
    attrs: {
      "items": _vm.roles,
      "label": "Select",
      "single-line": "",
      "hint": "Select a Role",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.currentRole),
      callback: function($$v) {
        _vm.currentRole = $$v
      },
      expression: "currentRole"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "max-width": "790px"
    },
    model: {
      value: (_vm.open_modal),
      callback: function($$v) {
        _vm.open_modal = $$v
      },
      expression: "open_modal"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "color": "primary"
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" Add role\n                ")], 1), _vm._v(" "), _c('NewRole', {
    attrs: {
      "activeDialog": _vm.activeDialog,
      "length": _vm.length
    }
  })], 1), _vm._v(" "), (_vm.currentRole !== 0) ? _c('v-dialog', {
    attrs: {
      "max-width": "790px",
      "fullscreen": _vm.screenWidth < 768,
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "dark": "",
      "color": "red"
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("delete")]), _vm._v(" Delete role\n                ")], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "center headline"
  }, [_vm._v("Confirm delete")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete this role \" " + _vm._s(_vm.selectedPriviledge['title']) + " \"?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteRole()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("No")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.selectedPriviledge) ? _c('v-card', [(_vm.selectedPriviledge) ? _c('v-list', {
    attrs: {
      "three-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Events")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.events.create_event),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.events, "create_event", $$v)
      },
      expression: "selectedPriviledge.events.create_event"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Create Events")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to create events")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Activity Stream")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.activity_stream.post_to_activity),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.activity_stream, "post_to_activity", $$v)
      },
      expression: "selectedPriviledge.activity_stream.post_to_activity"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Post to Activity Stream")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to create post in activity stream")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Economic Impact")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.giveAllAccessToEconomicImpact()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.economic_impact.all_access),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.economic_impact, "all_access", $$v)
      },
      expression: "selectedPriviledge.economic_impact.all_access"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("All Access")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Give full access to the economic impact module")])], 1)], 1), _vm._v(" "), _vm._l((_vm.analysisList), function(analysis, index) {
    return _c('v-list-tile', {
      key: index
    }, [_c('v-list-tile-action', [_c('v-checkbox', {
      attrs: {
        "readonly": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.unCheckEconomicImpactAllAccess()
        }
      },
      model: {
        value: (_vm.selectedPriviledge.economic_impact[analysis.id]),
        callback: function($$v) {
          _vm.$set(_vm.selectedPriviledge.economic_impact, analysis.id, $$v)
        },
        expression: "selectedPriviledge.economic_impact[analysis.id]"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(analysis.text))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Give access to the "), _c('span', {
      staticStyle: {
        "text-transform": "lowercase"
      }
    }, [_vm._v(_vm._s(analysis.text))])])], 1)], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Chat")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.chat.group_chat),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.chat, "group_chat", $$v)
      },
      expression: "selectedPriviledge.chat.group_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Group Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to send messages in groups")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.chat.private_chat),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.chat, "private_chat", $$v)
      },
      expression: "selectedPriviledge.chat.private_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Private Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to send private messages across users")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.chat.video_chat),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.chat, "video_chat", $$v)
      },
      expression: "selectedPriviledge.chat.video_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Video Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Enables users access to video chats")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.chat.voice_chat),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.chat, "voice_chat", $$v)
      },
      expression: "selectedPriviledge.chat.voice_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Voice Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Enables users access to voice chats")])], 1)], 1)], 2) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Email Updates")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    },
    model: {
      value: (_vm.selectedPriviledge.email_updates.access),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.email_updates, "access", $$v)
      },
      expression: "selectedPriviledge.email_updates.access"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Enable Access")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allows users to receive email updates")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action'), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Set limit for Email Update")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Limit the number of email updates")])], 1), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.selectedPriviledge.email_updates.limit),
      callback: function($$v) {
        _vm.$set(_vm.selectedPriviledge.email_updates, "limit", $$v)
      },
      expression: "selectedPriviledge.email_updates.limit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "5",
      "value": 5
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "10",
      "value": 10
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.updateData()
      }
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.selectedPriviledge) ? _c('div', {
    staticClass: "pa-4"
  }, [_c('v-alert', {
    attrs: {
      "color": "secondary",
      "value": true
    }
  }, [_vm._v("\n            No Role has been selected, Please select role to display above\n          ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('PageFooter')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1464)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1299),
  /* template */
  __webpack_require__(1667),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f809752",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(846),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-060504ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 842:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      items: [{
        icon: '',
        text: 'Home',
        link: '/admin/settings/home'
      }, {
        icon: '',
        text: 'Settings',
        link: '/admin/settings/pages',
        children: [{
          icon: '',
          text: 'General Settings',
          link: '/admin/settings/pages',
          query: {
            page: 'general-settings'
          }
        }, {
          icon: '',
          text: 'Email Settings',
          link: '/admin/settings/pages',
          query: {
            page: 'email-settings'
          }
        }, {
          icon: '',
          text: 'Directory',
          link: '/admin/settings/pages',
          query: {
            page: 'directory'
          }
        }, {
          icon: '',
          text: 'Resources',
          link: '/admin/settings/pages',
          query: {
            page: 'resources'
          }
        }, {
          icon: '',
          text: 'Opportunities',
          link: '/admin/settings/pages',
          query: {
            page: 'opportunities'
          }
        }, {
          icon: '',
          text: 'History',
          link: '/admin/settings/pages',
          query: {
            page: 'history'
          }
        }, {
          icon: '',
          text: 'DoD Contract Analytics',
          link: '/admin/settings/pages',
          query: {
            page: 'dod-contract-analytics'
          }
        }, {
          icon: '',
          text: 'Bid Alerts',
          link: '/admin/settings/pages',
          query: {
            page: 'bid_alerts'
          }
        }, {
          icon: '',
          text: 'Questionnaire',
          link: '/admin/settings/pages',
          query: {
            page: 'questionnaire'
          }
        }, {
          icon: '',
          text: 'Favorites',
          link: '/admin/settings/pages',
          query: {
            page: 'favorites'
          }
        }, {
          icon: '',
          text: 'Tracking',
          link: '/admin/settings/pages',
          query: {
            page: 'tracking'
          }
        }]
      }, {
        icon: '',
        text: 'Users',
        link: '/admin/settings/users',
        children: [{
          icon: '',
          text: 'Manage Users',
          link: '/admin/settings/users',
          query: {
            page: 'manage-users'
          }
        }, {
          icon: '',
          text: 'Usage Tracking',
          link: '/admin/settings/users',
          query: {
            page: 'usage-tracking'
          }
        }, {
          icon: '',
          text: 'Default Chat Contact',
          link: '/admin/settings/users',
          query: {
            page: 'default-chat-contact'
          }
        }]
      }, {
        icon: '',
        text: 'Access',
        link: '/admin/settings/priviledges'
      }, {
        icon: '',
        text: 'Resources',
        link: '/admin/resources/all'
      }, {
        icon: '',
        text: 'Companies',
        link: '/admin/companies',
        children: [{
          icon: '',
          text: 'Update Company',
          link: '/admin/companies/update-company'
        }, {
          icon: '',
          text: 'Add Company',
          link: '/admin/companies/add-company'
        }]
      }, {
        icon: '',
        text: 'Requests',
        link: '/admin/settings/requests',
        children: [{
          icon: '',
          text: 'Activity Stream',
          link: '/admin/settings/requests',
          query: {
            page: 'activity'
          }
        }, {
          icon: '',
          text: 'Events',
          link: '/admin/settings/requests',
          query: {
            page: 'events'
          }
        }, {
          icon: '',
          text: 'Company Submission',
          link: '/admin/settings/requests',
          query: {
            page: 'companies'
          }
        } // {
        //   icon: '',
        //   text: 'Group Post',
        //   link: '/admin/settings/requests',
        //   query: {
        //     page: 'groups'
        //   }
        // },
        // {
        //   icon: '',
        //   text: 'Group Events',
        //   link: '/admin/settings/requests',
        //   query: {
        //     page: 'group-events'
        //   }
        // }
        ]
      }, {
        icon: '',
        text: 'Feedback/Support',
        link: '/admin/settings/support',
        children: [{
          text: 'Feedback',
          link: '/admin/settings/support',
          query: {
            page: 'feedback'
          }
        }, {
          text: 'Help Requests',
          link: '/admin/settings/support',
          query: {
            page: 'help-requests'
          }
        }]
      }, {
        icon: '',
        text: 'Admin Tutorials',
        link: '/admin/settings/tutorials',
        children: [{
          text: 'All Tutorials',
          link: '/admin/settings/tutorials',
          query: {
            page: 'all'
          }
        }, {
          text: 'Manage Tutorials',
          link: '/admin/settings/tutorials',
          query: {
            page: 'manage'
          }
        }]
      }]
    };
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  },
  methods: {
    checkUserRole: function checkUserRole() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var usr, fb, user, alert;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                usr = _this.$store.getters.getUserDetails;
                fb = _this.$firebase.database().ref();
                _context.next = 4;
                return fb.child('users/' + usr.uid.toString()).once('value');

              case 4:
                user = _context.sent;

                if (user.role !== 1) {
                  alert = {
                    ative: true,
                    header: 'Access denied',
                    text: "You don't have access on this page",
                    okText: 'Ok',
                    cancelText: ''
                  };

                  _this.$store.dispatch('triggerAlert', alert);

                  _this.$router.push('/user/feed');
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    isOpen: function isOpen(rootPath) {
      return this.$route.fullPath.indexOf(rootPath) > -1;
    }
  }
};

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".sidebar-menu[data-v-060504ef]{top:55px}.list__tile--active[data-v-060504ef],.list__tile--active[data-v-060504ef]:hover{background-color:rgba(0,0,0,.1)!important}.menu_list_data[data-v-060504ef]{width:100%}.menu_list_data li[data-v-060504ef]{margin-bottom:12px;padding-right:20px}.menu_list_item_data[data-v-060504ef]{font-size:16px}.list__group i[data-v-060504ef],.list__tile i[data-v-060504ef]{color:#a2a2a2}.list__tile__action[data-v-060504ef]{min-width:30px}.list__group__header--active[data-v-060504ef],.list__group__items[data-v-060504ef]{background-color:rgba(0,0,0,.4)}.list[data-v-060504ef]{background:transparent!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Components/AdminSideBar.vue"],"names":[],"mappings":"AACA,+BACE,QAAU,CACX,AAID,gFACE,yCAAgD,CACjD,AACD,iCACE,UAAY,CACb,AACD,oCACE,mBAAoB,AACpB,kBAAoB,CACrB,AACD,sCACE,cAAgB,CACjB,AACD,+DACE,aAAe,CAChB,AACD,qCACE,cAAgB,CACjB,AAID,mFACE,+BAAqC,CACtC,AACD,uBACE,gCAAmC,CACpC","file":"AdminSideBar.vue","sourcesContent":["\n.sidebar-menu[data-v-060504ef] {\n  top: 55px;\n}\n.list__tile--active[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n.list__tile--active[data-v-060504ef]:hover {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n.menu_list_data[data-v-060504ef] {\n  width: 100%;\n}\n.menu_list_data li[data-v-060504ef] {\n  margin-bottom: 12px;\n  padding-right: 20px;\n}\n.menu_list_item_data[data-v-060504ef] {\n  font-size: 16px;\n}\n.list__group i[data-v-060504ef], .list__tile i[data-v-060504ef] {\n  color: #a2a2a2;\n}\n.list__tile__action[data-v-060504ef] {\n  min-width: 30px;\n}\n.list__group__items[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.list__group__header--active[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.list[data-v-060504ef] {\n  background: transparent !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(843);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("91f344b8", content, true, {});

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "sidebar-menu",
    style: ({
      backgroundColor: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "dark": "",
      "fixed": "",
      "value": true,
      "mobile-break-point": 768,
      "clipped": true
    }
  }, [_c('v-list', {
    staticClass: "menu_list_data",
    attrs: {
      "dark": ""
    }
  }, _vm._l((_vm.items), function(item, i) {
    return (item.children) ? _c('v-list-group', {
      key: i,
      attrs: {
        "value": _vm.isOpen(item.link)
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator",
        "color": "grey"
      },
      slot: "activator"
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "menu_list_item_data",
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "white--text menu_list_item_data"
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(sub_item, i) {
      return _c('v-list-tile', {
        key: i,
        attrs: {
          "router": "",
          "to": sub_item.query ? ((sub_item.link) + "/" + (sub_item.query.page)) : ("" + (sub_item.link))
        }
      }, [_c('v-list-tile-action', [_c('v-icon', {
        staticClass: "menu_list_item_data",
        attrs: {
          "color": "white"
        }
      }, [_vm._v(_vm._s(sub_item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
        staticClass: "white--text menu_list_item_data"
      }, [_vm._v("\n            " + _vm._s(sub_item.text) + "\n          ")])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      attrs: {
        "router": "",
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "menu_list_item_data",
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "white--text menu_list_item_data"
    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")])], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".page-footer[data-v-1c309d0c]{position:absolute;height:50px;right:0;bottom:0;left:300px;background:#f9f9fa;border-top:1px solid #e1e6ef;text-align:center;line-height:50px;color:#151b1e}.page-footer p[data-v-1c309d0c]{margin:0}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Components/PageFooter.vue"],"names":[],"mappings":"AACA,8BACE,kBAAmB,AACnB,YAAa,AACb,QAAS,AACT,SAAU,AACV,WAAY,AACZ,mBAAoB,AACpB,6BAA8B,AAC9B,kBAAmB,AACnB,iBAAkB,AAClB,aAAe,CAChB,AACD,gCACI,QAAU,CACb","file":"PageFooter.vue","sourcesContent":["\n.page-footer[data-v-1c309d0c] {\n  position: absolute;\n  height: 50px;\n  right: 0;\n  bottom: 0;\n  left: 300px;\n  background: #f9f9fa;\n  border-top: 1px solid #e1e6ef;\n  text-align: center;\n  line-height: 50px;\n  color: #151b1e;\n}\n.page-footer p[data-v-1c309d0c] {\n    margin: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(871);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("2eac6325", content, true, {});

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(873)
}
var Component = __webpack_require__(14)(
  /* script */
  null,
  /* template */
  __webpack_require__(877),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c309d0c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 877:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer mt-4"
  }, [_c('p', [_vm._v("Georgia Defense-Exchange")])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.1b558f37d2c2763eba3a.js